import React from 'react';
import './OrderPage.css';

import { PageTitle } from '../../../components';
import { OrderNow } from '../..';


 
const OrderPage = () => {

  return (

    <div className='order-page'>

      {/* Page Title */}
      <PageTitle title={'Order Now'} page={'Order Now'} />

      {/* Order Form */}
      <OrderNow />

    </div>

  );

}

export default OrderPage;